interface StationeryIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const StationeryIcon = (props: StationeryIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <g>
        <path
          style={{ fill: fillColor }}
          d="M34.1,27.8c-0.1-0.1-0.2-0.2-0.2-0.4C33,22.3,32,17,31.1,11.8C31,11,31,10.1,29.8,10.3c-0.2-2.1-1.4-3.3-3-3.1
            c-0.7,0.1-1.4,0.4-1.9,0.9c-1,0.9-0.9,2.1-0.5,3.4c-2,0.2-3.8,0.6-5.7,0.6c-1.2,0-2.4-0.1-3.6-0.1l1.3,1.9c2.3-0.4,4.6-0.8,6.9-1.2
            c0.1,0.1,0.1,0.2,0.2,0.3c-0.4,0.4-0.8,0.7-1.1,1.2c-0.2,0.2-0.1,0.7-0.1,1c0.3-0.1,0.7-0.1,0.9-0.2c0.7-0.6,1.2-1.4,1.9-2
            c0.2-0.2,0.5-0.4,0.7-0.3c1.3,0.5,2.4,0.1,3.4-0.8c0.1-0.1,0.4-0.1,0.7-0.2c1,5.6,2.1,11.2,3.1,16.8c-6.2,1.1-12.3,2.1-18.5,3.2
            c-0.3-1.9-0.6-3.8-0.9-5.7l-0.2-0.1l-0.2-0.3c0,0,0-0.1-0.1-0.1l-1-1.4c0.2,1.4,0.4,2.9,0.7,4.3c0.1,0.5,0.1,1,0.2,1.7
            c-0.5,0-0.8,0-1.1,0c-1.2-0.1-2.3-0.1-3.7-0.2c0.2-3.5,0.5-6.9,0.7-10.4l-1-1.5c-0.1,1.9-0.2,3.8-0.4,5.7c-0.1,2-0.3,3.9-0.5,5.9
            c0,0.4,0,0.8,0.1,1.3c1.5,0.1,3,0.3,4.5,0.4c0.5,0,1,0.1,1.5,0.1c0.5,1.6,0.5,1.6,2.1,1.3c1.2-0.2,2.4-0.4,3.5-0.6
            c2.6-0.6,5.2,0,7.8,0c1.5,0,1.5,0,1.6-1.5c2-0.4,4-0.9,6-1.3C34.2,28.7,34.2,28.3,34.1,27.8z M27,11.6c-0.9,0.1-1.7-0.7-1.8-1.6
            c-0.1-0.9,0.6-1.7,1.5-1.8c0.9-0.1,1.7,0.6,1.8,1.5C28.7,10.7,27.9,11.6,27,11.6z"
        />
        <g id="_x38_30-pencil_x40_2x.png_1_">
          <g>
            <g>
              <path
                style={{ fill: fillColor }}
                d="M19.5,26.9l-0.3-0.1l-5.1-2.2l0,0c0,0,0,0,0,0L5.9,12.8c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1,0.1-0.3,0.2-0.4
                  l4.6-3.2c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.3,0.1,0.4,0.2l8.2,11.9l0,0l0,0.1l0,0.1l0,0.1l0,0l0.2,5.5l0,0
                  C19.8,26.8,19.6,26.9,19.5,26.9L19.5,26.9z M15.2,24l3.6,1.5l-0.2-3.9l-1.2-0.2l-0.2,1.1c-0.1,0.3-0.4,0.5-0.7,0.5l-1.1-0.2
                  L15.2,24z M8.9,15.1l5.4,7.8l0.2-0.9c0.1-0.3,0.4-0.5,0.7-0.5l1.1,0.2l0.2-1.1c0.1-0.3,0.4-0.5,0.7-0.5l0.9,0.2l-5.4-7.8
                  L8.9,15.1z M7.1,12.6l1.1,1.5l3.7-2.5l-1.1-1.5L7.1,12.6z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default StationeryIcon
